import Button from '@asphalt-react/button';
import { Refresh } from '@asphalt-react/iconpack';
import { Controls, Player } from '@lottiefiles/react-lottie-player';
import React, { useEffect, useRef, useState } from 'react';
import placeholderIcon from '../../assets/placeholderIcon.svg';
import styles from './AnimatedAssetSelector.module.css';

function AnimatedAssetSelector({ onAssetSelected, asset, heading, lottieRef }) {
  const [assetSrc, setAssetSrc] = useState(null);
  useEffect(() => {
    setAssetSrc(asset);
  }, [asset]);

  const replaceButton = () => {
    return (
      <Button
        nude
        qualifier={<Refresh />}
        onClick={() => {
          openAnimatedAssetSelector();
        }}>
        Replace
      </Button>
    );
  };

  const animatedAssetInput = useRef();

  const handleChange = (event) => {
    var file = event.target.files[0];
    event.target.value = '';
    if (file) {
      var fileReader = new FileReader();
      fileReader.onloadend = function (e) {
        if (file.type.indexOf('json') > 0) {
          setAssetSrc(fileReader.result);
          onAssetSelected(file, fileReader.result);
        }
      };
      fileReader.readAsDataURL(file);
    }
  };

  const openAnimatedAssetSelector = () => {
    animatedAssetInput.current.click();
  };

  return (
    <div className={styles.imageDisplayerContainer}>
      <input
        type='file'
        onChange={handleChange}
        ref={animatedAssetInput}
        accept='.json'
        draggable='true'
        className={styles.input}
      />
      <div className={styles.actionsContainer}>
        {assetSrc ? (
          <>
            <p className={styles.labelHeader}>{heading}</p>
            {replaceButton()}
          </>
        ) : (
          <p className={styles.labelHeader}>{heading}</p>
        )}
      </div>
      <div className={styles.imageContainer}>
        {assetSrc ? (
          <Player
            autoplay
            loop
            src={assetSrc}
            className={styles.animPlayer}
            lottieRef={lottieRef}>
            <Controls
              visible={true}
              buttons={['play', 'repeat', 'frame', 'debug']}
            />
          </Player>
        ) : (
          <div className={styles.placeholderContainer}>
            <img
              src={placeholderIcon}
              className={styles.placeholder}
              alt={'placeholder'}
            />
            <Button
              nude
              onClick={() => {
                openAnimatedAssetSelector();
              }}>
              Browse
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AnimatedAssetSelector;
